import {HTTP_METHODS} from '../httpMethods'

export const SEGMENTS_CONFIG = {
  // SEGMENTS_LIST: {
  //   endPoint: 'segment/segment-data',
  //   baseUrlKey: 'cepApiUrl',
  //   headers: {
  //     'x-api-key': import.meta.env[FeatureConfig.cepApiKey],
  //     'siteId': '21'
  //   },
  //   attachAuthIntercepter: false
  // }
  SEGMENTS_LIST: (searchQuery = '') => ({
    endPoint: `segment/groups${searchQuery ? `?search=${searchQuery}` : ''}`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.GET,
    headers: {
      scope: 'pepsi',
    },
  }),
  SEGMENTS_BASE: {
    endPoint: 'segment',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  },
  SEGMENTS_BY_GROUP_BASE: {
    endPoint: 'segment/groups',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  },
}
